<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Cf_Mg_User' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView
      [controlClose]="true"
      (onChange)="handleChange($event)"
      (onClose)="closeTab($event)"
      [activeIndex]="index"
      >
      <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
        <div class="table-tools">
          <button (click)="add($event)"
            class="p-button p-component p-button-text-only btn-square"
            >
            {{'Cf_Add_User' | translate}}
          </button>
        </div>
        <p-table
          #dt
          [selectionMode]="'single'"
          [columns]="listColumns"
          [value]="dataList"
          [rows]="100"
          [paginator]="true"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="showDetails($event)"
          (onFilter)="setFilteredList($event)"
          [sortField]="'name'"
          >
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ dataList.length }} {{'Cf_Users' | translate}}</span>
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th class="width-col-3">
                <i class="pi pi-copy" pTooltip="{{'Cf_Dup' | translate}}"></i>
              </th>
              <th class="width-auto">
                {{columns[0].header}}
                <p-dropdown
                  [options]="activeList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, columns[0].field, 'equals')"
                ></p-dropdown>
              </th>
              <th class="width-col-3" pTooltip="{{'Cf_Wiz' | translate}}">
                {{'Cf_W' | translate}}
              </th>
              <th class="width-col-3" pTooltip="{{'Cf_TypU' | translate}}">
                {{'Cf_T' | translate}}
              </th>
              <th [pSortableColumn]="columns[3].field" class="width-auto">
                <p-sortIcon [field]="columns[3].field"></p-sortIcon>{{columns[3].header}}
                <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[3].field, 'contains')"
                  style="color: darkgrey;">
                </th>
                <th [pSortableColumn]="columns[4].field" class="width-auto">
                  <p-sortIcon [field]="columns[4].field"></p-sortIcon>{{columns[4].header}}
                  <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[4].field, 'contains')"
                    style="color: darkgrey;">
                  </th>
                  <th [pSortableColumn]="columns[5].field" class="width-auto">
                    <p-sortIcon [field]="columns[5].field"></p-sortIcon>{{columns[5].header}}
                    <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[5].field, 'contains')"
                      style="color: darkgrey;">
                    </th>
                    <th [pSortableColumn]="columns[6].field" class="width-auto">
                      <p-sortIcon [field]="columns[6].field"></p-sortIcon>{{columns[6].header}}
                      <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[6].field, 'contains')"
                        style="color: darkgrey;">
                      </th>

                    </tr>
                  </ng-template>
                  <ng-template let-rowData let-columns="columns" pTemplate="body">
                    <tr [pSelectableRow]="rowData">
                      <td (click)="clickcolDup($event, rowData)">
                        <i class="pi pi-copy"></i>
                      </td>
                      <td class="width-auto">
                        <div class="align">
                          @if (rowData[columns[0].field] === 0) {
                            <i
                              class="pi pi-times"
                            ></i>
                          }
                          @if (rowData[columns[0].field] === 1) {
                            <i
                              class="pi pi-check"
                            ></i>
                          }
                        </div>
                      </td>
                      <td class="width-auto">
                        <div class="align">
                          @if (rowData[columns[1].field] === 1) {
                            <i
                              class="pi pi-star"
                            ></i>
                          }
                        </div>
                      </td>
                      <td class="width-auto">
                        <div class="align">
                          @if (rowData[columns[2].field] === 0) {
                            <i
                              class="pi pi-user"
                            ></i>
                          }
                          @if (rowData[columns[2].field] === 1) {
                            <i
                              class="pi pi-book"
                            ></i>
                          }
                        </div>
                      </td>
                      <td class="width-auto">
                        {{ rowData[columns[3].field] }}
                      </td>
                      <td class="width-auto">
                        {{ rowData[columns[4].field] }}
                      </td>
                      <td class="width-auto">
                        {{ rowData[columns[5].field] }}
                      </td>
                      <td class="width-auto">
                        {{ rowData[columns[6].field] }}
                      </td>
                    </tr>
                  </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
        @for (item of itemsSelected; track item; let i = $index) {
          <p-tabPanel
            header="{{ item._label }}"
            [selected]="i == index - 1"
            [closable]="true"
            >
            @if (item.id === -1) {
              <app-add-user
                [userListDelegate]="userListDelegate"
                [groupListBase]="groupListBase"
                (onCancel)="cancelAdd($event)"
                (onValidate)="addTab($event)"
                >
              </app-add-user>
            }
            @if (item.id !== -1) {
              <app-edit-user
                [item]="item"
                [duplicate]="duplicate"
                [userListDelegate]="userListDelegate"
                [groupListBase]="groupListBase"
                (onCancel)="closeTab($event)"
                (onValidate)="validateTab($event)"
                (onDeleteItem)="confirmDelete($event)"
                (onLoadItem)="onLoadItem($event)"
                >
              </app-edit-user>
            }
          </p-tabPanel>
        }
    </p-tabView>
  </div>
</div>
<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>